var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg04FullHappy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:hop 1.1s cubic-bezier(.3,.8,.4,1) infinite}\n@keyframes hop{0%,100%{transform:translateY(0) scale(1,1)}20%{transform:translateY(0) scale(1.08,.9)}55%{transform:translateY(-22px) scale(.95,1.06)}}\n.sp{transform-origin:center;animation:twink 1.1s ease-in-out infinite}\n.p2{animation-delay:.35s}.p3{animation-delay:.7s}\n@keyframes twink{0%,100%{opacity:.2;transform:scale(.5) rotate(0)}50%{opacity:1;transform:scale(1.2) rotate(45deg)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 118 Q90 98 106 118",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 118 Q150 98 166 118",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 146 Q120 178 144 146 Z",
    fill: "#0E2A2E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 146,
    r: 10,
    fill: "#FF9EB5",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 146,
    r: 10,
    fill: "#FF9EB5",
    opacity: 0.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD84D"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sp",
    d: "M28 70 l5 13 13 5 -13 5 -5 13 -5 -13 -13 -5 13 -5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sp p2",
    d: "M210 62 l4 11 11 4 -11 4 -4 11 -4 -11 -11 -4 11 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sp p3",
    d: "M200 190 l4 10 10 4 -10 4 -4 10 -4 -10 -10 -4 10 -4 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04FullHappy);
export default __webpack_public_path__ + "static/media/04-full-happy.2ffef3ca080806220b7538609d0d7db6.svg";
export { ForwardRef as ReactComponent };